<template>
  <el-popover
    placement="top"
    v-model="show"
    :visible-arrow="false"
    popper-class="upload-popper"
    trigger="click"
  >
    <div class="popover">
      <div class="upload-main-container">
        <div class="upload-left-container">
          <div
            class="left-item"
            @click="publisherId = group.publisherId"
            :key="group.publisherId"
            v-for="group in groups"
          >
            <div class="publisher-item" :class="{ [group.state]: true }">
              <div class="image" v-lazy:background-image="group.image">
                <number-show
                  class="publisher-num"
                  :style="{ left: group.num > 9 ? '10px' : '16px' }"
                  :size="20"
                  v-if="group.num > 0"
                  :num="group.num"
                ></number-show>
                <div
                  v-if="group.socialNetwork === 1"
                  class="ins-user-icon"
                ></div>
                <div
                  v-if="group.socialNetwork === 2"
                  class="fb-page-user-icon"
                ></div>
                <div
                  v-if="group.socialNetwork === 3"
                  class="fb-group-user-icon"
                ></div>
                <div
                  v-if="group.socialNetwork === 4"
                  class="tw-user-icon"
                ></div>
              </div>
            </div>
          </div>
          <div class="other" :class="{ last: selectLast }">
            <div class="border"></div>
          </div>
        </div>
        <div v-if="show" class="upload-list">
          <div class="empty" v-if="list.length === 0">empty</div>
          <div :key="group.date" v-for="group in list">
            <div class="date">{{ group.date }}</div>
            <div
              class="upload-item-container"
              :class="{ expired: item.status === 'expired' }"
              @click="resetPost(item)"
              :key="item.uuid"
              v-for="item in group.groups"
            >
              <div
                class="upload-post-item"
                :class="{ story: item.type === 'story' }"
              >
                <div
                  class="image-container"
                  v-if="item.data.mediaList.length > 0"
                >
                  <crop-img-component
                    v-if="item.type === 'story'"
                    class="image"
                    :model="item.data.mediaList[0]"
                  ></crop-img-component>
                  <thumbnails
                    class="image"
                    v-if="item.type === 'post'"
                    :cover="true"
                    :mul="item.data.mediaList.length > 1"
                    :model="item.data.mediaList[0]"
                  ></thumbnails>
                </div>
                <div class="right-container">
                  <div class="time">
                    {{ item.data.form.postTime | formatTime }}
                  </div>
                  <div class="status">
                    <process-loading
                      v-if="item.loading"
                      class="loading"
                      :init="true"
                    ></process-loading>
                    <span v-else>{{ item.status }}</span>
                  </div>
                </div>
                <div class="operation" v-if="!item.loading">
                  <div
                    class="operation-icon reload"
                    v-if="item.status !== 'expired'"
                    @click.stop="reload(item)"
                  ></div>
                  <div
                    class="operation-icon remove"
                    @click.stop="remove(item.data.uuid)"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="reference">
      <div
        class="upload-btn-container"
        :class="{ shake: uploadList.length > 0 }"
      >
        <div class="upload-close" v-if="!open && show"></div>
        <div class="upload-btn" v-if="!open">
          <div class="icon"></div>
          <number-show
            class="num"
            :num="uploadList.length"
            v-if="uploadList.length > 0 && !show"
          ></number-show>
        </div>
        <template v-else>
          <div class="open-upload-icon"></div>
          <div class="upload-menu-title"></div>
          <number-show
            class="num"
            v-if="uploadList.length > 0 && !show"
            :num="uploadList.length"
          ></number-show>
        </template>
      </div>
    </div>
  </el-popover>
</template>
<style lang="less">
@import "../../assets/style/theme.less";

.upload-popper {
  background: transparent !important;
  box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.3) !important;
  border-radius: 8px !important;
  outline: none;
}
</style>
<style lang="less" scoped>
@import "../../assets/style/theme.less";
.ins-user-icon,
.fb-page-user-icon,
.fb-group-user-icon {
  width: 13px;
  height: 13px;
}
.shake {
  animation-name: shake;
  animation-duration: 1s;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  .upload-btn .icon,
  .open-upload-icon {
    background-image: url("../../../public/images/menu/Message_Reb@3x.png") !important;
  }
}

@keyframes shake {
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-2px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(2px, 0, 0);
  }
}

.upload-btn-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 160px;
  cursor: pointer;
  margin-bottom: 5px;

  &:hover {
    color: @theme-color;

    .open-upload-icon {
      background-image: url("../../../public/images/menu/Message_Reb@3x.png");
    }
  }

  .open-upload-icon {
    height: 25px;
    width: 25px;
    background-size: contain;
    background-image: url("../../../public/images/menu/Message@3x.png");
  }

  .upload-menu-title {
    font-size: 14px;
    flex: 1;
    font-weight: 500;
    margin-left: 12px;
  }

  .upload-close {
    height: 37px;
    width: 37px;
    background-size: contain;
    background-image: url("../../../public/images/menu/icon_close@3x.png");
  }

  .upload-btn {
    height: 37px;
    width: 37px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .icon {
      height: 24px;
      width: 24px;
      background-size: contain;
      background-image: url("../../../public/images/menu/Message@3x.png");
    }

    .num {
      position: absolute;
      left: 22px;
      bottom: 20px;
    }
  }

  .num {
    font-size: 11px;
  }
}

.popover {
  width: 330px;
  border-radius: 8px;

  .upload-main-container {
    display: flex;
    height: 330px;
    border-radius: 8px 8px 0 0;

    .upload-left-container {
      width: 54px;
      border-radius: 8px 0 0 8px;
      display: flex;
      flex-direction: column;
      overflow: auto;
      overflow-x: hidden;
      background: #e6e6e6;

      .other {
        flex: 1;
        min-height: 20px;

        &.last {
          background: white;

          .border {
            border-radius: 0 4px 0 0;
            background: #e6e6e6;
            height: 100%;
          }
        }
      }

      .left-item {
        background: white;

        .publisher-item {
          background: #e6e6e6;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 44px;
          cursor: pointer;

          .publisher-num {
            position: absolute;
            top: -6px;
            transform: scale(0.7);
          }

          &.active {
            background: white;

            .image {
              filter: none;
              position: relative;
            }
          }

          &.before {
            border-radius: 0 0 4px 0;
          }

          &.after {
            border-radius: 0 4px 0 0;
          }

          &:hover {
            opacity: 0.7;
          }

          .image {
            width: 25px;
            height: 25px;
            background-size: contain;
            border-radius: 50%;
            filter: grayscale(100%);
          }
        }
      }
    }

    .upload-list {
      padding-bottom: 10px;
      overflow: auto;
      background: white;
      border-radius: 8px 8px 8px 8px;
      flex: 1;
      color: #000;

      .empty {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: gray;
      }

      .date {
        font-weight: 500;
        font-size: 14px;
        padding-top: 10px;
        padding-left: 10px;
      }

      .upload-item-container {
        padding: 0 10px;

        &.expired {
          cursor: pointer;

          &:hover {
            background: @hover-color;
          }
        }

        .upload-post-item {
          display: flex;
          height: 55px;
          align-items: center;
          border-bottom: solid 1px #eceff1;

          .image-container {
            width: 38px;
            height: 38px;
            display: flex;
            align-items: center;
            justify-content: center;

            .image {
              width: 36px;
              height: 36px;
              border: 1px solid white;
            }
          }

          &.story {
            .image-container {
              border-radius: 50%;
              background: linear-gradient(to bottom right, #c6008b, #e1013a);

              .image {
                border-radius: 50%;
              }
            }
          }

          .right-container {
            flex: 1;
            margin-left: 10px;

            .time {
              font-size: 14px;
            }

            .status {
              color: @theme-color;
              font-size: 12px;
              height: 22px;
              position: relative;

              .loading {
                bottom: 3px !important;
              }
            }
          }

          .operation {
            display: flex;

            .operation-icon {
              cursor: pointer;
              height: 24px;
              width: 24px;
              background-size: contain;

              &.reload {
                background-image: url("../../../public/images/menu/UploadFailedRED@3x.png");
              }

              &.remove {
                background-image: url("../../../public/images/menu/UploadDeleteRED@3x.png");
                margin-left: 20px;
              }

              &:hover {
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
}
</style>
<script>
import { postForm, initPostFormData } from "../../service/post";
import thumbnails from "../../components/media/crop/Thumbnail";
import moment from "moment-timezone";
import processLoading from "../../components/common/process/Index";
import { mapGetters } from "vuex";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_ID,
} from "../../store/mutation-types";
import NumberShow from "../common/NumShow";
import CropImgComponent from "../media/crop/CropImg";
import { updateUserInfo } from "../../service/user";
import { showErrorMsg } from "../../utils/errors";

export default {
  name: "UploadStatus",
  components: { CropImgComponent, NumberShow, thumbnails, processLoading },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uploadList: [],
      resultList: [],
      publisherId: "", // 当前选中的publisher
      show: false, // 是否显示上传进度条
    };
  },
  filters: {
    formatTime(val) {
      return moment(val).format("HH:mm");
    },
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      currentPublisherId: CURRENT_PUBLISHER_ID,
    }),
    /**
     * 计算当前显示的上传列表
     */
    list() {
      const list = this.uploadList
        .filter((u) => u.publisherId === this.publisherId)
        .sort((u1, u2) => {
          return moment(u1.postTime).isAfter(u2.postTime) ? -1 : 1;
        });
      // 对列表数据按照时间进行分组
      let timeGroup = [];
      list.forEach((item) => {
        const form = item.data.form;
        const date = moment.tz(form.postTime, form.tzName).format("MMM DD");
        const time = timeGroup.find((t) => t.date === date);
        if (time) {
          time.groups.push(item);
        } else {
          timeGroup.push({
            date,
            groups: [item],
          });
        }
      });
      return timeGroup;
    },
    /**
     * 对数据进行分组
     */
    groups() {
      const groups = this.user.linkedInstagramList.map((i) => {
        return {
          publisherId: i.publisherId,
          socialNetwork: i.socialNetwork,
          image: i.image,
          num: this.uploadList.filter((u) => u.publisherId === i.publisherId)
            .length,
        };
      });
      // 获取选中项
      const selectIndex = groups.findIndex(
        (g) => g.publisherId === this.publisherId
      );
      // 如果存在选中项则调整
      if (selectIndex !== -1) {
        groups[selectIndex].state = "active";
        if (groups[selectIndex - 1]) {
          groups[selectIndex - 1].state = "before";
        }
        if (groups[selectIndex + 1]) {
          groups[selectIndex + 1].state = "after";
        }
      }
      return groups;
    },
    selectLast() {
      const selectIndex = this.groups.findIndex(
        (g) => g.publisherId === this.publisherId
      );
      if (this.groups.length > 0 && selectIndex === this.groups.length - 1) {
        return true;
      }
      return false;
    },
  },
  destroyed() {
    //   // 销毁的时候去掉监听
    this.$bus.$off("uploadSchedule");
    this.$bus.$off("uploadSuccess");
  },
  created() {
    try {
      // 监听schedule上传任务
      this.$bus.$on("uploadSchedule", async ({ forms, id, info }) => {
        const formamtForms = initPostFormData({ forms });
        // 过滤掉原来已经存在的
        this.remove(id);
        const all = [];
        formamtForms.forEach((form) => {
          all.push(this.send(form, info));
        });
        await Promise.all(all);
      });
      window.onbeforeunload = (e) => {
        if (this.uploadList.findIndex((i) => i.loading) !== -1) {
          // 如果存在一个正在loading中则弹出提示
          e.returnValue = "Refresh this page will cause data lost.";
          return "Refresh this page will cause data lost.";
        }
      };
    } catch (e) {
      showErrorMsg(e);
    }
  },
  watch: {
    show(val) {
      // 当上传组件打开的时候判断是否存在过期
      if (val) {
        this.uploadList.forEach((u) => {
          if (
            moment().isAfter(
              moment.tz(u.data.form.postTime, u.data.form.tzName)
            )
          ) {
            u.status = "expired";
          }
        });
        // 将当前选中变更为和主页面选中人相同
        this.publisherId = this.currentPublisherId;
      }
    },
  },
  methods: {
    async reload(uploadItem) {
      uploadItem.loading = true;
      uploadItem.success = false;
      const item = uploadItem.data;
      try {
        await postForm({ type: uploadItem.type, item });
        uploadItem.success = true;
        uploadItem.status = "success";
        // 成功之后清楚当前选项
        this.remove(item.uuid);
        return true;
      } catch (e) {
        console.error("上传失败", e);
        uploadItem.status = "upload failed";
        this.show = true;
        return false;
      } finally {
        uploadItem.loading = false;
      }
    },
    /**
     * 再次发送
     */
    async resetPost(uploadItem) {
      if (this.loading || uploadItem.status !== "expired") {
        return;
      }
      this.show = false;
      const scheduleForm = {
        uuid: uploadItem.uuid, // 唯一标示
        images: uploadItem.data.mediaList, // 发送的图片
        type: "again", // 发送的类型
        form: uploadItem.data.form, // 发送的表单
        mediaType: "post", // 发送的类型
      };
      this.$bus.$emit("showScheduleForm", scheduleForm);
    },
    /**
     * 删除对应条目
     */
    remove(id) {
      const removeIndex = this.uploadList.findIndex((u) => u.data.uuid === id);
      if (removeIndex !== -1) {
        this.uploadList.splice(removeIndex, 1);
      }
    },
    /**
     * 发送单条数据
     * @param item
     */
    async send(item, info) {
      const uploadItem = {
        publisherId: item.form.publisherIds[0],
        uuid: item.uuid, // 唯一标识
        data: item, // 数据
        type: item.type, // 发送的类型
        loading: true, // 是否处于发送中
        success: false, // 发送是否成功
      };
      try {
        this.uploadList.push(uploadItem);
        let result = await postForm({ type: uploadItem.type, item });
        uploadItem.success = true;
        uploadItem.status = "success";
        // 成功之后清楚当前选项
        this.remove(item.uuid);
        result.forEach((r) => {
          const publisherPost = this.resultList.find(
            (rl) => r.publisherId === rl.publisherId
          );
          if (publisherPost) {
            publisherPost.items.push(...r.items);
          } else {
            this.resultList.push(r);
          }
        });
        if (this.uploadList.findIndex((i) => i.loading) === -1) {
          this.$bus.$emit("scheduleSuccess", this.resultList, info);
          updateUserInfo({});
          this.resultList = [];
        }
        return true;
      } catch (e) {
        uploadItem.status = "upload failed";
        this.show = true;
        return false;
      } finally {
        uploadItem.loading = false;
      }
    },
  },
};
</script>
